import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Matrix from "./pages/Matrix";
import Referrals from "./pages/Referrals";
import Benefits from "./pages/Benefits";
import Admin from "./pages/Admin";
import AwaitingActivation from "./pages/AwaitingActivation";
import Profile from "./pages/Profile";
import MyOrders from "./pages/MyOrders";
import EarningsReport from "./pages/EarningsReport";
import Withdraw from "./pages/Withdraw";
import Transfer from "./pages/Transfer";
import MyPartners from "./pages/MyPartners";
import Partners from "./pages/Partners";
import BecomePartner from "./pages/BecomePartner";
import ReferralLink from "./pages/ReferralLink";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminGuard from "./components/AdminGuard";
import ImpersonationBanner from "./components/ImpersonationBanner";
import ScrollReveal from "./components/ScrollReveal";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/cadastro" element={<Register />} />
              <Route path="/esqueci-senha" element={<ForgotPassword />} />
              <Route path="/redefinir-senha" element={<ResetPassword />} />
              <Route path="/aguardando-ativacao" element={<AwaitingActivation />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/matriz" element={<ProtectedRoute associateOnly><Matrix /></ProtectedRoute>} />
              <Route path="/indicacoes" element={<ProtectedRoute associateOnly><Referrals /></ProtectedRoute>} />
              <Route path="/beneficios" element={<Benefits />} />
              <Route path="/pedidos" element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />
              <Route path="/relatorio" element={<ProtectedRoute associateOnly><EarningsReport /></ProtectedRoute>} />
              <Route path="/saque" element={<ProtectedRoute associateOnly><Withdraw /></ProtectedRoute>} />
              <Route path="/transferir" element={<ProtectedRoute><Transfer /></ProtectedRoute>} />
              <Route path="/minhas-empresas" element={<ProtectedRoute associateOnly><MyPartners /></ProtectedRoute>} />
              <Route path="/parceiros" element={<Partners />} />
              <Route path="/seja-parceiro" element={<ProtectedRoute><BecomePartner /></ProtectedRoute>} />
              <Route path="/perfil" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/admin" element={<AdminGuard><Admin /></AdminGuard>} />
              <Route path="/:code" element={<ReferralLink />} />
            </Routes>
            <ScrollReveal />
            <ImpersonationBanner />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
